// /** @format */

// import axios from 'axios';
// import { notification } from 'antd';

// import { LOCAL_STORAGE } from '../../../v2-config/constants/local-storage.constant';
// import { ENV_FUNCTION_USER, ENV_COUNTRY } from '../../../hooks/enviroment';

// export async function serviceLoginUser(item) {
// 	return await axios({
// 		method: 'POST',
// 		url: `${ENV_FUNCTION_USER}/user/login-panel/${ENV_COUNTRY}`,
// 		data: {
// 			email: item.email,
// 			password: item.password,
// 		},
// 	})
// 		.then((response) => {
// 			if (response.data.statusCode === 200) {
// 				if (response.data.data.rols.length >= 1) {
// 					console.log('response login', response.data.data);
// 					localStorage.setItem(LOCAL_STORAGE.LOG, true);
// 					localStorage.setItem(LOCAL_STORAGE.USER, JSON.stringify(response.data.data));
// 					notification['success']({
// 						message: 'Bienvenido al Panel',
// 						description: 'Recuerde que los permisos del panel dependen de su usuario.',
// 					});
// 					return response.data.data;
// 				} else {
// 					notification['error']({
// 						message: 'Acceso Denegado',
// 						description: 'Usted no tiene permisos para ingresar en el panel',
// 					});
// 				}
// 			} else {
// 				notification['error']({
// 					message: response.data.error,
// 					description: response.data.message,
// 				});
// 				return { data: response.data };
// 			}
// 		})
// 		.catch((error) => {
// 			notification['error']({
// 				message: `Error Servicio o No existe varible Rols`,
// 				description: `${ENV_FUNCTION_USER}/user/login-panel/${ENV_COUNTRY}`,
// 			});
// 		});
// }

import { AxiosAdapter } from '../../_config/adapters/axios/axios.adapter';
import { Http } from '../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';

export class Service {
	async findUser(token) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.API_PHARMACY}/user-panel/get-me`,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
